import { Language } from 'models/settings';
import { SUPPORTED_LANGUAGES } from 'constants/index';

export function replaceLangInUrl(url: string, lang: Language) {
  const u = new URL(window.location.href);
  u.pathname = replaceLangInPath(u.pathname, lang);
  return u.toString();
}

function replaceLangInPath(pathname: string, nextLang: Language): string {
  const segments = pathname.split('/').filter(Boolean);

  if (segments.length === 0) {
    return `/${nextLang}`;
  }

  if (SUPPORTED_LANGUAGES.includes(segments[0] as Language)) {
    segments[0] = nextLang;
  } else {
    segments.unshift(nextLang);
  }

  return '/' + segments.join('/');
}
